<style scoped>
  .selected { font-weight: bold }
  li { cursor: pointer }
</style>

<template>
  <div class="col-12 attributesBlock sizeDropBlock">
    <span class="attr-title" v-html="`${attributeGroup.attributeGroupName}`"></span>
    <button class="selectDropSize" v-on:click="visible = !visible">{{ getSelectedText || t('selection') }}
      <i class="lni lni-chevron-down"></i>
    </button>
    <div v-show="visible" class="toggleAttrsBlk">
      <ul>
        <li v-for="attribute in attributeGroup.attributes"
            :key="attribute.attributeId"
            v-on:click="setSelected(attribute.attributeId)"
            :class="selected === attribute.attributeId ? 'selected' : ''">
          {{ attribute.attributeName }}
        </li>
      </ul>
    </div>
    <span class="attr-prop" v-show="getSelectedText.length > 0" v-html="`${getSelectedText}`"></span>
  </div>
</template>

<script>
export default {
  name: 'AttributeTextSelector',
  props: ['attributeGroup'],
  data () {
    return {
      version: '0.0.2',
      visible: false,
      selected: null
    }
  },
  computed: {
    getSelectedText () {
      if (!this.selected) {
        return ''
      }
      let selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    }
  },
  methods: {
    setSelected (attributeId) {
      this.selected = attributeId
      this.visible = false
      this.$emit('attribute-clicked', attributeId)
    }
  }
}
</script>
